<template>
    <div id="stdenis-dash">
        <router-view/>
    </div>
</template>

<script>
    import {firestoreDB} from '../../config/firebase'

    const parishioners = firestoreDB.collection("parishioners");

    export default {
        name: "Dash",
        mounted(){
            let tmpID = sessionStorage.getItem('dashboardID');
            if(tmpID){
                parishioners.doc(tmpID).get().then((doc) => {
                    if(!doc.exists){
                        this.$router.replace({name:'Login'})
                    }
                });
            }else{
                this.$router.replace({name:'Login'})
            }


        }
    }
</script>

<style scoped>
    #stdenis-dash{
        background:rgb(250,250,250);
    }
</style>